import React, { Component } from "react";
import AutosizeTextarea from 'react-autosize-textarea';
import { enqueueSnackbar } from "notistack";
import { Tooltip, Menu } from "antd";
import { FileTextOutlined, SaveOutlined, ArrowLeftOutlined, FileDoneOutlined } from '@ant-design/icons';
import ScrollUpButton from "react-scroll-up-button";
import addImage from './images/add.png';
import deleteImage from './images/delete.png';
import Loading from "./loader";

class VoteAgendaRedact extends Component {
    state = {
    questions: [
        {
            QuestionId: 1,
            DetailId: 0,
            Question: '',
            Decision: '',
            DetailText: '',
            SingleVotePerShareholder: false,
            Interest: false,
            Cumulative: false,
            SeatCount: 0,
            isCumulativeChecked: false,
            isSeatCountChecked: false,
            cumulativeItems: [],
            extraQuestionsCount: 0,
            extraQuestions: [],
            deletedDetails: [],
        }
    ],
    nextQuestionId: 2,
    isButtonDisabled: false,
    isLoading: true,
    deleted_question_ids: [],
    showScrollUp: false, // Отслеживание видимости кнопки "Наверх"
};

    componentDidMount() {
        window.addEventListener('scroll', this.handleScroll, { passive: true });
        const { is_staff, is_superuser } = this.props;
        if (!is_staff && !is_superuser) {
            alert("Доступ запрещен");
            window.location.href = `/#/`;
            return;
        }

        const getMeetingIdFromUrl = () => {
            const match = window.location.href.match(/\/voteAgendaRedact\/(\d+)/);
            return parseInt(match[1], 10);
        };

        const meetingId = getMeetingIdFromUrl();
        this.fetchAgendaData(meetingId);
    }

    async componentDidUpdate(prevProps) {
        const { is_staff, is_superuser } = this.props;

        if (prevProps.is_staff !== is_staff || prevProps.is_superuser !== is_superuser) {
            if (!is_staff && !is_superuser) {
                alert("Доступ запрещен");
                window.location.href = `/#/`;
            }
        }
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    }

    fetchAgendaData = async (meetingId) => {
        const API_ADDRESS = process.env.REACT_APP_API_ADDRESS;
        try {
            const response = await fetch(`${API_ADDRESS}get_agenda/${meetingId}/`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${localStorage.getItem('token')}`,
                },
            });
            if (response.status === 401) {
                alert("Время сессии истекло. Пожалуйста выполните вход.");
                document.getElementById("logoutBttn").click();
                return;
            }
            if (!response.ok) {
                const errorData = await response.json();
                console.error('Ошибка сервера:', errorData);
                enqueueSnackbar(`Ошибка получения данных`, { variant: 'error' });
                this.setState({ isLoading: false });
                return;
            }
            const data = await response.json();
            const sortedAgenda = [...data.agenda].sort((a, b) =>
                parseInt(a.question_id, 10) - parseInt(b.question_id, 10)
            );

            if (data.agenda.length === 0) {
                this.setState({
                    questions: [
                        {
                            QuestionId: 1,
                            Question: '',
                            Decision: '',
                            SingleVotePerShareholder: false,
                            Interest: false,
                            Cumulative: false,
                            SeatCount: 0,
                            isCumulativeChecked: false,
                            isSeatCountChecked: false,
                            cumulativeItems: [],
                            extraQuestionsCount: 0,
                            extraQuestions: [],
                            deletedDetails: [],
                        }
                    ],
                    nextQuestionId: 2,
                    isLoading: false,
                });
            } else {
                const questions = sortedAgenda.map(item => {
                    const allDetails = data.question_details.filter(d => d.question_id === item.question_id);

                    // Для кумулятивного вопроса — все детали считаются кумулятивными
                    const cumulativeItems = item.cumulative
                        ? allDetails.map(detail => ({
                            Id: detail.id,
                            DetailId: detail.detail_id,
                            CumulativeItem: detail.detail_text,
                        }))
                        : [];

                    // Для дополнительных вопросов — только если НЕ кумулятивный и есть места
                    const extraQuestions = !item.cumulative && item.seat_count > 0
                        ? allDetails.map(detail => ({
                            Id: detail.id,
                            DetailId: detail.detail_id,
                            ExtraQuestion: detail.detail_text,
                        }))
                        : [];

                    // Если вопрос кумулятивный — количество кандидатов = длина cumulativeItems
                    // Если обычный — extraQuestionsCount = длина extraQuestions
                    const extraQuestionsCount = item.cumulative
                        ? cumulativeItems.length
                        : extraQuestions.length;

                    return {
                        QuestionId: item.question_id,
                        Question: item.question || '',
                        Decision: item.decision || '',
                        SingleVotePerShareholder: item.single_vote_per_shareholder,
                        Interest: item.interest,
                        Cumulative: item.cumulative,
                        SeatCount: item.seat_count,
                        isCumulativeChecked: item.cumulative,
                        isSeatCountChecked: !item.cumulative && item.seat_count > 0,
                        cumulativeItems,
                        extraQuestionsCount,
                        extraQuestions,
                        deletedDetails: [],
                    };
                });

                this.setState({
                    questions,
                    nextQuestionId: sortedAgenda.length + 1,
                    isLoading: false,
                });
            }
        } catch (error) {
            enqueueSnackbar('Произошла ошибка при получении данных', { variant: 'error' });
            this.setState({ isLoading: false });
        }
    };

    handleSaveClick = () => {
        const getMeetingIdFromUrl = () => {
            const match = window.location.href.match(/\/voteAgendaRedact\/(\d+)/);
            return parseInt(match[1], 10);
        };
        const meetingId = getMeetingIdFromUrl();
        if (!meetingId) return;

        const agendaData = this.state.questions.map(question => ({
            meeting_id: meetingId,
            question_id: question.QuestionId,
            single_vote_per_shareholder: question.SingleVotePerShareholder || false,
            interest: question.Interest || false,
            question: question.Question || '',
            decision: question.Decision || '',
            cumulative: question.Cumulative || false,
            seat_count: question.SeatCount || 0,
        }));

        // Собираем ВСЕ deletedDetails из всех вопросов
        const deletedDetails = this.state.questions.flatMap(
            q => (q.deletedDetails || []).filter(id => id != null)
        );

        // Формируем questionDetailData ТОЛЬКО для активных элементов
        const questionDetailData = this.state.questions.flatMap(question => {
            // Если кумулятивный вопрос отключен - не включаем его элементы
            const cumulativeItems = question.isCumulativeChecked
                ? question.cumulativeItems
                : [];

            // Если дополнительные вопросы отключены - не включаем их элементы
            const extraQuestions = question.isSeatCountChecked
                ? question.extraQuestions
                : [];

            return [
                ...cumulativeItems.map(item => ({
                    meeting_id: meetingId,
                    question_id: question.QuestionId,
                    detail_id: typeof item.DetailId === 'string' ? parseInt(item.DetailId.split('-')[2], 10) : item.DetailId,
                    detail_text: item.CumulativeItem || '',
                })),
                ...extraQuestions.map(item => ({
                    meeting_id: meetingId,
                    question_id: question.QuestionId,
                    detail_id: typeof item.DetailId === 'string' ? parseInt(item.DetailId.split('-')[1], 10) : item.DetailId,
                    detail_text: item.ExtraQuestion || '',
                })),
            ];
        });

        const sendData = {
            agenda: agendaData,
            question_details: questionDetailData,
            deleted_question_ids: this.state.deleted_question_ids,
            deleted_details: deletedDetails,
        };

        this.updateAgenda(sendData.agenda, sendData.question_details, sendData.deleted_question_ids, sendData.deleted_details);
    };

    updateAgenda = async (agendaData, questionDetailData, deletedQuestionIds, deletedDetails) => {
        const API_ADDRESS = process.env.REACT_APP_API_ADDRESS;
        try {
            const response = await fetch(`${API_ADDRESS}update_agenda/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${localStorage.getItem('token')}`,
                },
                body: JSON.stringify({
                    agenda: agendaData,
                    question_details: questionDetailData,
                    deleted_question_ids: deletedQuestionIds,
                    deleted_details: deletedDetails,
                }),
            });

            if (response.status === 401) {
                alert("Время сессии истекло. Пожалуйста выполните вход.");
                document.getElementById("logoutBttn").click();
                return;
            }

            if (!response.ok) {
                const errorData = await response.json();
                console.error('Ошибка сервера:', errorData);
                enqueueSnackbar(`Ошибка сохранения данных`, { variant: 'error' });
                return;
            }

            const data = await response.json();
            enqueueSnackbar('Вопросы успешно сохранены', { variant: 'success' });
        } catch (error) {
            enqueueSnackbar('Произошла ошибка при сохранении данных', { variant: 'error' });
        }
    };

    // Добавление нового вопроса
    handleAddQuestion = () => {
        const newQuestion = {
            QuestionId: this.state.nextQuestionId,
            DetailId: 0,
            Question: '',
            Decision: '',
            SingleVotePerShareholder: false,
            Interest: false,
            Cumulative: false,
            SeatCount: 0,
            isCumulativeChecked: false,
            isSeatCountChecked: false,
            cumulativeItems: [],
            extraQuestionsCount: 0,
            extraQuestions: [],
            deletedDetails: [],
        };

        this.setState((prevState) => ({
            questions: [...prevState.questions, newQuestion],
            nextQuestionId: prevState.nextQuestionId + 1,
        }));
    };

    //Дополнительные вопросы
    handleExtraQuestionsCountChange = (questionId, value) => {
        let count = parseInt(value, 10);
        if (isNaN(count) || count < 0) {
            count = 0;
        }

        this.setState((prevState) => ({
            questions: prevState.questions.map(question =>
                question.QuestionId === questionId
                    ? { ...question, SeatCount: count }
                    : question
            ),
        }));
    };

    //Метод для обработки изменения текста дополнительных вопросов
    handleExtraQuestionChange = (questionId, detailId, value) => {
        this.setState((prevState) => ({
            questions: prevState.questions.map(question =>
                question.QuestionId === questionId
                    ? {
                        ...question,
                        extraQuestions: question.extraQuestions.map(extraQuestion =>
                            extraQuestion.DetailId === detailId
                                ? { ...extraQuestion, ExtraQuestion: value }
                                : extraQuestion
                        ),
                    }
                    : question
            ),
        }));
    };

    handleCandidateCountChange = (questionId, value) => {
        let count = parseInt(value, 10);
        if (isNaN(count) || count < 0) count = 0;

        this.setState((prevState) => {
            const updatedQuestions = prevState.questions.map(question => {
                if (question.QuestionId !== questionId) return question;

                const currentExtraQuestions = question.extraQuestions || [];
                const newExtraQuestions = [...currentExtraQuestions];
                const deletedDetails = [];

                // Удаление лишних
                if (count < newExtraQuestions.length) {
                    for (let i = count; i < newExtraQuestions.length; i++) {
                        if (newExtraQuestions[i].Id) {
                            deletedDetails.push(newExtraQuestions[i].Id);
                        }
                    }
                    newExtraQuestions.splice(count);
                }
                // Добавление новых
                else if (count > newExtraQuestions.length) {
                    for (let i = newExtraQuestions.length; i < count; i++) {
                        newExtraQuestions.push({
                            Id: null,
                            DetailId: `${questionId}-${i + 1}`,
                            ExtraQuestion: ''
                        });
                    }
                }

                return {
                    ...question,
                    extraQuestionsCount: count,
                    extraQuestions: newExtraQuestions,
                    deletedDetails: [
                        ...(question.deletedDetails || []),
                        ...deletedDetails
                    ]
                };
            });

            return { questions: updatedQuestions };
        });
    };

    // Удаление вопроса по его QuestionId
    handleDeleteQuestion = (questionId) => {
        const { questions } = this.state;
        if (questions.length === 1) {
            enqueueSnackbar('Нельзя удалить последний вопрос', { variant: 'warning' });
            return;
        }

        const questionToDelete = questions.find(q => q.QuestionId === questionId);
        const detailsToDelete = questionToDelete?.extraQuestions?.map(e => e.Id).filter(Boolean) || [];
        const cumulativeToDelete = questionToDelete?.cumulativeItems?.map(c => c.Id).filter(Boolean) || [];

        const allDetailIdsToDelete = [
            ...detailsToDelete,
            ...cumulativeToDelete,
            ...(questionToDelete?.deletedDetails || [])
        ].filter(id => id != null);

        const updatedQuestions = questions
            .filter(question => question.QuestionId !== questionId)
            .map((question, index) => ({
                ...question,
                QuestionId: index + 1,
            }));

        this.setState((prevState) => ({
            questions: updatedQuestions,
            nextQuestionId: prevState.nextQuestionId - 1,
            deleted_question_ids: [...prevState.deleted_question_ids, questionId],
            deletedDetails: [
                ...(prevState.deletedDetails || []),
                ...allDetailIdsToDelete
            ],
        }));
    };

    // Обработчик изменения текста вопроса
    handleQuestionChange = (questionId, value) => {
        this.setState((prevState) => ({
            questions: prevState.questions.map(question =>
                question.QuestionId === questionId ? { ...question, Question: value } : question
            ),
        }));
    };

    // Обработчик изменения текста решения
    handleDecisionChange = (questionId, value) => {
        this.setState((prevState) => ({
            questions: prevState.questions.map(question =>
                question.QuestionId === questionId ? { ...question, Decision: value } : question
            ),
        }));
    };

    // Обработчик изменения чекбокса "Один голос на акционера"
    handleSingleVoteChange = (questionId, event) => {
        const isChecked = event.target.checked;
        this.setState((prevState) => ({
            questions: prevState.questions.map(question =>
                question.QuestionId === questionId
                    ? { ...question, SingleVotePerShareholder: isChecked }
                    : question
            ),
        }));
    };

    // Обработчик изменения чекбокса "Интерес"
    handleInterestChange = (questionId, event) => {
        const isChecked = event.target.checked;
        this.setState((prevState) => ({
            questions: prevState.questions.map(question =>
                question.QuestionId === questionId
                    ? { ...question, Interest: isChecked }
                    : question
            ),
        }));
    };

    // Обработчик изменения чекбокса "Кумулятивный вопрос"
    handleCumulativeChange = (questionId, event) => {
        const isChecked = event.target.checked;
        this.setState((prevState) => {
            const question = prevState.questions.find(q => q.QuestionId === questionId);
            if (!question) return prevState;

            const deletedDetails = [];

            // При отключении — помечаем все текущие cumulativeItems на удаление
            if (!isChecked && question.cumulativeItems.length > 0) {
                const idsToDelete = question.cumulativeItems
                    .map(item => item.Id)
                    .filter(id => id != null);
                deletedDetails.push(...idsToDelete);
            }

            let newCumulativeItems = [];
            if (isChecked) {
                const count = question.extraQuestionsCount || 0;
                // Попробуем восстановить существующие данные, если они есть
                newCumulativeItems = Array.from({ length: count }, (_, index) => {
                    const existing = question.cumulativeItems?.[index];
                    return {
                        Id: existing?.Id || null,
                        DetailId: existing?.DetailId || `${questionId}-cumulative-${index + 1}`,
                        CumulativeItem: existing?.CumulativeItem || '',
                    };
                });
            }

            return {
                questions: prevState.questions.map(q =>
                    q.QuestionId === questionId
                        ? {
                            ...q,
                            Cumulative: isChecked,
                            isCumulativeChecked: isChecked,
                            isSeatCountChecked: false,
                            SeatCount: 0,
                            extraQuestionsCount: 0,
                            extraQuestions: [],
                            cumulativeItems: newCumulativeItems,
                            deletedDetails: [
                                ...(q.deletedDetails || []),
                                ...deletedDetails
                            ],
                        }
                        : q
                ),
            };
        });
    };

    handleCumulativeCandidateCountChange = (questionId, value) => {
        let count = parseInt(value, 10);
        if (isNaN(count) || count < 0) count = 0;

        this.setState((prevState) => {
            const updatedQuestions = prevState.questions.map(question => {
                if (question.QuestionId !== questionId) return question;

                const currentCumulativeItems = question.cumulativeItems || [];
                const newCumulativeItems = [...currentCumulativeItems];
                const deletedDetails = [];

                // Удаление лишних
                if (count < newCumulativeItems.length) {
                    for (let i = count; i < newCumulativeItems.length; i++) {
                        if (newCumulativeItems[i].Id) {
                            deletedDetails.push(newCumulativeItems[i].Id);
                        }
                    }
                    newCumulativeItems.splice(count);
                }
                // Добавление новых
                else if (count > newCumulativeItems.length) {
                    for (let i = newCumulativeItems.length; i < count; i++) {
                        newCumulativeItems.push({
                            Id: null,
                            DetailId: `${questionId}-cumulative-${i + 1}`,
                            CumulativeItem: ''
                        });
                    }
                }

                return {
                    ...question,
                    extraQuestionsCount: count,
                    cumulativeItems: newCumulativeItems,
                    deletedDetails: [
                        ...(question.deletedDetails || []),
                        ...deletedDetails
                    ]
                };
            });

            return { questions: updatedQuestions };
        });
    };

    // Обработка изменения чисел для Кумулятивных вопросов
    handleCumulativeCountChange = (questionId, value) => {
        let count = parseInt(value, 10);
        if (isNaN(count) || count < 0) {
            count = 0;
        }

        const newCumulativeItems = Array.from({ length: count }, (_, index) => ({
            DetailId: `${questionId}-cumulative-${index + 1}`, // Уникальный DetailId
            CumulativeItem: '',
        }));

        this.setState((prevState) => ({
            questions: prevState.questions.map(question =>
                question.QuestionId === questionId
                    ? {
                        ...question,
                        cumulativeItems: newCumulativeItems, // Создаем массив элементов
                    }
                    : question
            ),
        }));
    };

    // Обработка изменения текста для Кумулятивных вопросов
    handleCumulativeItemChange = (questionId, detailId, value) => {
        this.setState((prevState) => ({
            questions: prevState.questions.map(question =>
                question.QuestionId === questionId
                    ? {
                        ...question,
                        cumulativeItems: question.cumulativeItems.map(item =>
                            item.DetailId === detailId
                                ? { ...item, CumulativeItem: value }
                                : item
                        ),
                    }
                    : question
            ),
        }));
    };

    // Обработчик изменения чекбокса "Дополнительные вопросы"
    handleSeatCountChange = (questionId, event) => {
        const isChecked = event.target.checked;
        this.setState((prevState) => {
            const question = prevState.questions.find(q => q.QuestionId === questionId);
            if (!question) return prevState;

            const deletedDetails = [];
            if (!isChecked) {
                deletedDetails.push(...question.extraQuestions.map(item => item.Id));
            }

            return {
                questions: prevState.questions.map(q =>
                    q.QuestionId === questionId
                        ? {
                            ...q,
                            isSeatCountChecked: isChecked,
                            isCumulativeChecked: false,
                            Cumulative: false,
                            SeatCount: isChecked ? q.SeatCount : 0,
                            extraQuestionsCount: isChecked ? q.extraQuestionsCount : 0,
                            cumulativeItems: isChecked ? [] : q.cumulativeItems,
                            extraQuestions: isChecked ? q.extraQuestions : [],
                            deletedDetails: [
                                ...(q.deletedDetails || []),
                                ...deletedDetails
                            ],
                        }
                        : q
                ),
            };
        });
    };

    // Проверка на возможность сохранения
    checkSaveButtonState = () => {
        const allQuestionsValid = this.state.questions.every(question =>
            question.Question.trim() !== '' &&
            question.Decision.trim() !== '' &&
            question.extraQuestions.every(extraQuestion => extraQuestion.ExtraQuestion.trim() !== '')
        );

        this.setState({ isButtonDisabled: !allQuestionsValid });
    };

    handleBackClick = () => {
        window.history.back();
    };

    handlePreviewAgenda = () => {
        const getMeetingIdFromUrl = () => {
            const match = window.location.href.match(/\/voteAgendaRedact\/(\d+)/);
            return parseInt(match[1], 10);
        };

        const meetingId = getMeetingIdFromUrl();
        window.location.href = `/#/voteAgendaPreShow/${meetingId}/`;
    };

    highlightRow = (questionId) => {
        setTimeout(() => {
            const row = document.getElementById(`question-${questionId}`);
            if (row) {
                row.classList.add('blink-animation');
                setTimeout(() => row.classList.remove('blink-animation'), 1000);
                row.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        }, 100);
    };

    handleScroll = () => {
        if (this.scrollTimeout) {
            clearTimeout(this.scrollTimeout);
        }

        this.scrollTimeout = setTimeout(() => {
            const showScrollUp = window.scrollY > 130;
            this.setState({ showScrollUp });
        }, 50);
    };

    render() {
  const { questions, isButtonDisabled, isLoading, showScrollUp } = this.state;

  if (isLoading) {
    return <Loading />;
  }

  return (
      <>
          <div className="page-container">
              {/* Основной контейнер: меню + форма */}
              <div className="agnd-layout-container">
                  {/* Заголовок */}
                  <div className="agnd-header-row">
                      <div style={{display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '20px'}}>
                          <div className="back-button-wrapper" onClick={this.handleBackClick}>
                              <ArrowLeftOutlined
                                  style={{fontSize: '20px', cursor: 'pointer', marginTop: '4px'}}
                              />
                          </div>
                          <h1>Вопросы</h1>
                      </div>
                  </div>

                  <div className="agnd-content-wrapper">
                      {/* Левая колонка: два меню */}
                      <div className="agnd-sidebar-questions">
                          {/* Первое меню: Сохранить */}
                          <Menu
                              mode="inline"
                              style={{
                                  border: '1px solid #ccc',
                                  borderRadius: '8px',
                                  backgroundColor: '#fff',
                              }}
                          >
                              <Menu.Item
                                  key="save"
                                  icon={<SaveOutlined/>}
                                  className="menu-item-color"
                                  onClick={this.handleSaveClick}>
                                  Сохранить
                              </Menu.Item>
                          </Menu>

                          {/* Второе меню: Бюллетень */}
                          <Menu
                              mode="inline"
                              style={{
                                  border: '1px solid #ccc',
                                  borderRadius: '8px',
                                  backgroundColor: '#fff',
                              }}
                          >
                              <Menu.Item key="preview" icon={<FileTextOutlined/>} onClick={this.handlePreviewAgenda}>
                                  Бюллетень
                              </Menu.Item>
                          </Menu>

                          {/* Третье меню: Список вопросов */}
                          <Menu
                              mode="inline"
                              defaultOpenKeys={['questions-nav']}
                              selectedKeys={[]}
                              defaultSelectedKeys={[]}
                              style={{
                                  border: '1px solid #ccc',
                                  borderRadius: '8px',
                                  backgroundColor: '#fff',
                              }}
                          >
                              <Menu.SubMenu
                                  key="questions-nav"
                                  title="Список вопросов"
                                  icon={<FileDoneOutlined/>}
                              >
                                  {questions.length > 0 ? (
                                      questions.map((question) => (
                                          <Menu.Item
                                              key={`nav-${question.QuestionId}`}
                                              onClick={() => this.highlightRow(question.QuestionId)}
                                              selectable={false}
                                          >
                                              Вопрос №{question.QuestionId}
                                          </Menu.Item>
                                      ))
                                  ) : (
                                      <Menu.Item disabled>Нет вопросов</Menu.Item>
                                  )}
                              </Menu.SubMenu>
                          </Menu>
                      </div>

                      {/* Правая часть: редактирование вопросов */}
                      <div style={{flex: 1}}>
                          {questions.map((question, index) => (
                              <div
                                  key={question.QuestionId}
                                  id={`question-${question.QuestionId}`}
                                  className={`grid-container3 ${index > 0 ? 'with-margin-top' : ''}`}
                              >
                                  <div className="row">
                                      <div><b>№{index + 1}</b></div>
                                  </div>
                                  <div className="row3">
                                      <div></div>
                                  </div>
                                  <div className="row">
                                      <div>Текст вопроса</div>
                                      <div>
                                          <AutosizeTextarea
                                              className="main-input"
                                              name="Question"
                                              value={question.Question}
                                              onChange={(e) => {
                                                  this.handleQuestionChange(question.QuestionId, e.target.value);
                                                  this.checkSaveButtonState();
                                              }}
                                              style={{resize: 'none'}}
                                              rows="1"
                                          />
                                      </div>
                                  </div>
                                  <div className="row">
                                      <div>Текст решения вопроса</div>
                                      <div>
                                          <AutosizeTextarea
                                              className="main-input"
                                              name="Decision"
                                              value={question.Decision}
                                              onChange={(e) => {
                                                  this.handleDecisionChange(question.QuestionId, e.target.value);
                                                  this.checkSaveButtonState();
                                              }}
                                              style={{resize: 'none'}}
                                              rows="1"
                                          />
                                      </div>
                                  </div>
                                  <div className="row3">
                                      <div>Один голос на акционера</div>
                                      <div>
                                          <input
                                              type="checkbox"
                                              style={{width: '15px', height: '15px', cursor: 'pointer'}}
                                              name="SingleVotePerShareholder"
                                              checked={question.SingleVotePerShareholder}
                                              onChange={(e) => this.handleSingleVoteChange(question.QuestionId, e)}
                                          />
                                      </div>
                                  </div>
                                  <div className="row3">
                                      <div>Наличие заинтересованности</div>
                                      <div>
                                          <input
                                              type="checkbox"
                                              style={{width: '15px', height: '15px', cursor: 'pointer'}}
                                              name="Interest"
                                              checked={question.Interest}
                                              onChange={(e) => this.handleInterestChange(question.QuestionId, e)}
                                          />
                                      </div>
                                  </div>
                                  <div className="row3">
                                      <div>Кумулятивный вопрос</div>
                                      <div>
                                          <input
                                              type="checkbox"
                                              style={{width: '15px', height: '15px', cursor: 'pointer'}}
                                              name="Cumulative"
                                              checked={question.isCumulativeChecked}
                                              onChange={(e) => this.handleCumulativeChange(question.QuestionId, e)}
                                              disabled={question.isSeatCountChecked}
                                          />
                                      </div>
                                  </div>
                                  <div className="row3">
                                      <div>Дополнительные вопросы</div>
                                      <div>
                                          <input
                                              type="checkbox"
                                              style={{width: '15px', height: '15px', cursor: 'pointer'}}
                                              name="SeatCount"
                                              checked={question.isSeatCountChecked}
                                              onChange={(e) => this.handleSeatCountChange(question.QuestionId, e)}
                                              disabled={question.isCumulativeChecked}
                                          />
                                      </div>
                                  </div>

                                  {/* Поля для количества мест и кандидатов */}
                                  {(question.isSeatCountChecked || question.isCumulativeChecked) && (
                                      <div className="row">
                                          <div>Количество мест:</div>
                                          <input
                                              type="number"
                                              className="numb-input2"
                                              value={question.SeatCount || ''}
                                              onChange={(e) => {
                                                  const inputValue = e.target.value;
                                                  if (/^\d*$/.test(inputValue) || inputValue === '') {
                                                      this.handleExtraQuestionsCountChange(question.QuestionId, e.target.value);
                                                  }
                                              }}
                                          />
                                          <div>Количество кандидатов:</div>
                                          <input
                                              type="number"
                                              className="numb-input2"
                                              value={question.extraQuestionsCount || ''}
                                              onChange={(e) => {
                                                  const inputValue = e.target.value;
                                                  if (/^\d*$/.test(inputValue) || inputValue === '') {
                                                      if (question.isCumulativeChecked) {
                                                          this.handleCumulativeCandidateCountChange(question.QuestionId, e.target.value);
                                                      } else {
                                                          this.handleCandidateCountChange(question.QuestionId, e.target.value);
                                                      }
                                                  }
                                              }}
                                          />
                                      </div>
                                  )}

                                  {/* Поля дополнительных вопросов */}
                                  {question.isSeatCountChecked &&
                                      question.extraQuestions.length > 0 &&
                                      question.extraQuestions.map((extraQuestion, idx) => (
                                          <div className="row" key={extraQuestion.DetailId}>
                                              {idx === 0 ? (
                                                  <div>Имя:</div>
                                              ) : (
                                                  <div></div>
                                              )}
                                              <div>
                                                  <input
                                                      type="text"
                                                      className="main-input"
                                                      value={extraQuestion.ExtraQuestion || ''}
                                                      placeholder="Ввод..."
                                                      onChange={(e) =>
                                                          this.handleExtraQuestionChange(question.QuestionId, extraQuestion.DetailId, e.target.value)
                                                      }
                                                  />
                                              </div>
                                          </div>
                                      ))
                                  }

                                  {/* Поля кумулятивных вопросов */}
                                  {question.isCumulativeChecked && question.cumulativeItems.length > 0 && (
                                      (() => {
                                          return question.cumulativeItems.map((cumulativeItem, idx) => (
                                              <div className="row" key={cumulativeItem.DetailId}>
                                                  {idx === 0 ? (
                                                      <div>Имя:</div>
                                                  ) : (
                                                      <div></div>
                                                  )}
                                                  <div>
                                                      <input
                                                          type="text"
                                                          className="main-input"
                                                          value={cumulativeItem.CumulativeItem || ''}
                                                          placeholder="Ввод..."
                                                          onChange={(e) => {
                                                              this.handleCumulativeItemChange(question.QuestionId, cumulativeItem.DetailId, e.target.value);
                                                          }}
                                                      />
                                                  </div>
                                              </div>
                                          ));
                                      })()
                                  )}

                                  {/* Кнопки: Удалить и Добавить */}
                                  <div style={{display: 'flex', gap: '10px', justifyContent: 'left'}}>
                                      <div>
                                          <Tooltip title="Удалить вопрос">
                                              <img
                                                  src={deleteImage}
                                                  alt="Удалить"
                                                  style={{
                                                      cursor: 'pointer',
                                                      width: '25px',
                                                      height: '25px'
                                                  }}
                                                  onClick={() => this.handleDeleteQuestion(question.QuestionId)}
                                              />
                                          </Tooltip>
                                      </div>
                                      {index === questions.length - 1 && (
                                          <div>
                                              <Tooltip title="Добавить вопрос">
                                                  <img
                                                      src={addImage}
                                                      alt="Добавить"
                                                      style={{
                                                          cursor: 'pointer',
                                                          width: '25px',
                                                          height: '25px'
                                                      }}
                                                      onClick={this.handleAddQuestion}
                                                  />
                                              </Tooltip>
                                          </div>
                                      )}
                                  </div>
                              </div>
                          ))}
                      </div>
                  </div>
              </div>
              <div>
                  <ScrollUpButton/>
              </div>
          </div>
      </>
  );
    }
}

export default VoteAgendaRedact;